export interface LoginCardBranding {
  cardOpacity?: number | null;
  cardBlur?: number | null;
}

export function buildLoginCardCssRules(
  s: string,
  branding: LoginCardBranding | null | undefined,
): string[] {
  const raw = branding?.cardOpacity;
  const rules: string[] = [];
  if (typeof raw === "number" && !Number.isNaN(raw)) {
    const opacity = Math.min(1, Math.max(0, raw));
    if (opacity < 1) {
      rules.push(
        `${s}[data-ui="login-card"] { background-color: rgba(255, 255, 255, ${opacity}); }`,
      );
    }
  }

  const rawBlur = branding?.cardBlur;
  if (typeof rawBlur === "number" && !Number.isNaN(rawBlur)) {
    const blur = Math.min(40, Math.max(0, rawBlur));
    if (blur > 0) {
      rules.push(
        `${s}[data-ui="login-card"] { backdrop-filter: blur(${blur}px); -webkit-backdrop-filter: blur(${blur}px); }`,
      );
    }
  }

  return rules;
}
